import React, { Children } from 'react';
import {
  arrayOf, oneOfType, oneOf, shape, number, node
} from 'prop-types';
import classNames from 'classnames';

import './MobileFirstResponsiveLayout.scss';

export const REST_OF_LINE = 'REST_OF_LINE';
export const FULL_WIDTH = 'FULL_WIDTH';
export const FULL_WIDTH_ALIGN_RIGHT = 'FULL_WIDTH_ALIGN_RIGHT';

export const MobileRow = ({ children }) => children;

MobileRow.propTypes = {
  children: node,
  desktop: shape({
    cssOrder: number,
    growth: oneOf([FULL_WIDTH, REST_OF_LINE]),
    fullWidthAlign: oneOf([FULL_WIDTH_ALIGN_RIGHT])
  })
};

export const MobileFirstResponsiveLayout = ({ children }) => {
  return (
    <div className="mobile-first-responsive-layout">
      {Children.toArray(children)
        .filter((child) => child)
        .map((mobileRow, i) => {
          const { cssOrder, growth, fullWidthAlign } = mobileRow.props.desktop || {};

          const isFullWidth = growth === FULL_WIDTH;
          const isRestOfLine = growth === REST_OF_LINE;
          const isFullWidthAlignRight = fullWidthAlign === FULL_WIDTH_ALIGN_RIGHT;

          const classes = classNames(
            'mobile-first-responsive-layout__row',
            { 'mobile-first-responsive-layout__row--desktop-growth-rest-of-line': isRestOfLine },
            { 'mobile-first-responsive-layout__row--desktop-growth-full-width': isFullWidth },
            { 'mobile-first-responsive-layout__row--desktop-growth-full-width-align-right': isFullWidthAlignRight }
          );

          return (
            <div
              key={i}
              className={classes}
              style={{
                order: cssOrder
              }}
            >
              {mobileRow}
            </div>
          );
        })}
    </div>
  );
};

MobileFirstResponsiveLayout.propTypes = {
  // The node should only be a MobileRow
  children: oneOfType([node, arrayOf(node)])
};

MobileFirstResponsiveLayout.defaultProps = {
  children: []
};

MobileFirstResponsiveLayout.displayName = 'MobileFirstResponsiveLayout';